import axios from 'axios';


const BASE_URL = 'http://localhost:8080';

export default axios.create({
    baseURL: BASE_URL
});


export const axiosPrivate = axios.create({
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});
export const axiosPrivateFile = axios.create({
    headers: { 'Content-Type': 'multipart/form-data' },
    withCredentials: true
});